export const CELL_SIZE = 72;
export const BLOCK_PADDING = 5;
export const CORNER_RADIUS = 10;
export const FRAME_BORDER = 20;
export const SWIPE_GUARD_PX = 20;
export const MIN_TOUCH_TARGET_PX = 44;
export const MAX_UNDOS = 30;
// Animation durations (ms) — match blockjam_anim_* RC key defaults
// ANIM_SLIDE_MS is the full-motion duration; reduced-motion plays at 50% (150ms)
export const ANIM_SLIDE_MS = 300;
export const ANIM_SHAKE_MS = 200;
export const ANIM_EXIT_MS = 300;
export const ANIM_CELEBRATION_MS = 1800;
// WP-36.5 — CONFETTI_COLORS moved to `renderer/confetti.ts`, next to the code
// that draws them. It had been dead here since WP-35.19 deleted the renderer
// that used it.
